module.exports = __webpack_public_path__ + "img/talking_snake.bf26cd53.jpg";